import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { INVENTORY } from "@/constants/testIds";
import { PRODUCT_CATEGORY_LABELS, formatQty } from "@/lib/inventoryConstants";

/** Vista dedicada a los productos por debajo del stock mínimo. */
export default function LowStockAlertsTab({ products, loading }) {
  if (loading) return <p className="text-center text-muted-foreground py-12">Cargando alertas...</p>;

  if (products.length === 0) {
    return (
      <div className="bg-white border border-border rounded-xl p-12 text-center" data-testid={INVENTORY.alertsEmptyState}>
        <CheckCircle2 className="w-10 h-10 text-[#5B7A54] mx-auto mb-3" />
        <p className="text-muted-foreground">Todo en orden: ningún producto esta por debajo de su stock mínimo.</p>
      </div>
    );
  }

  return (
    <div className="space-y-2" data-testid={INVENTORY.alertsList}>
      {products.map((p) => (
        <div key={p.id} className="bg-[#FBF3F1] border border-[#E9C9C6] rounded-xl p-4 flex items-center justify-between flex-wrap gap-2" data-testid={`${INVENTORY.alertItemPrefix}${p.id}`}>
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-5 h-5 text-[#A34B49] shrink-0" />
            <div>
              <p className="text-sm font-medium text-foreground">{p.name}</p>
              <p className="text-xs text-muted-foreground">{PRODUCT_CATEGORY_LABELS[p.category] || p.category}{p.brand ? ` \u00b7 ${p.brand}` : ""}</p>
            </div>
          </div>
          <p className="text-sm text-[#A34B49] font-medium shrink-0">
            {formatQty(p.stock_quantity)} / {formatQty(p.min_stock)} {p.unit}
          </p>
        </div>
      ))}
    </div>
  );
}
